export const status = [
    {
        "sr": 30,
        "value": "approved"
    },
    {
        "sr": 9,
        "value": "bound"
    },
    {
        "sr": 2,
        "value": "bound_and_inv"
    },
    {
        "sr": 13,
        "value": "cancelled_application"
    },
    {
        "sr": 15,
        "value": "cancelled_policy"
    },
    {
        "sr": 31,
        "value": "closed"
    },
    {
        "sr": 62,
        "value": "close_file_cannot_complete"
    },
    {
        "sr": 63,
        "value": "closed_file_not_a_opportunity_block"
    },
    {
        "sr": 4,
        "value": "declined"
    },
    {
        "sr": 12,
        "value": "dnoc_pending_cancellation"
    },
    {
        "sr": 14,
        "value": "expired"
    },
    {
        "sr": 8,
        "value": "filings_requested"
    },
    {
        "sr": 25,
        "value": "ignore_error"
    },
    {
        "sr": 27,
        "value": "indication_only"
    },
    {
        "sr": 61,
        "value": "mgmt_review_pending"
    },
    {
        "sr": 19,
        "value": "nor_pending_reinstatement"
    },
    {
        "sr": 6,
        "value": "not_taken"
    },
    {
        "sr": 29,
        "value": "online_submission_received"
    },
    {
        "sr": 26,
        "value": "other_see_notes"
    },
    {
        "sr": 7,
        "value": "pending_bind"
    },
    {
        "sr": 5,
        "value": "pending_information"
    },
    {
        "sr": 18,
        "value": "pending_quote"
    },
    {
        "sr": 32,
        "value": "pending_submission"
    },
    {
        "sr": 77,
        "value": "pending_telematics"
    },
    {
        "sr": 28,
        "value": "pending_uw_approval"
    },
    {
        "sr": 11,
        "value": "policy_issued"
    },
    {
        "sr": 17,
        "value": "quoted"
    },
    {
        "sr": 1,
        "value": "received"
    },
    {
        "sr": 16,
        "value": "reinstated"
    },
    {
        "sr": 10,
        "value": "released"
    },
    {
        "sr": 75,
        "value": "uw_approval_pending"
    },
    {
        "sr": 76,
        "value": "uw_approved"
    },
    {
        "sr": 3,
        "value": "uw_review"
    }
]

export const uw = [
    {
        "name": "Regina Adams",
        "sr_no": 12689
    },
    {
        "name": "Samarth Anand",
        "sr_no": 12445
    },
    {
        "name": "Raquel  Batson",
        "sr_no": 13450
    },
    {
        "name": "Matthew  Boeshart",
        "sr_no": 13528
    },
    {
        "name": "Jordan Bremer",
        "sr_no": 11219
    },
    {
        "name": "Isabel Carrillo",
        "sr_no": 12430
    },
    {
        "name": "Vincent Coca",
        "sr_no": 12190
    },
    {
        "name": "Connor Logue",
        "sr_no": 12796
    },
    {
        "name": "Enedina martinez",
        "sr_no": 12161
    },
    {
        "name": "Kimberly Porter",
        "sr_no": 12567
    },
    {
        "name": "Inder Randhawa",
        "sr_no": 12449
    },
    {
        "name": "Carolyn Rupp",
        "sr_no": 11217
    },
    {
        "name": "Gordon Rupp",
        "sr_no": 11620
    },
    {
        "name": "Shelli Ruth",
        "sr_no": 12687
    },
    {
        "name": "Robin  Samberg",
        "sr_no": 12795
    },
    {
        "name": "Timothy Stephanic",
        "sr_no": 11218
    },
    {
        "name": "Bryce Thompson",
        "sr_no": 13525
    },
    {
        "name": "Michael Wright",
        "sr_no": 12037
    },
    {
        "name": "Kristi konkler",
        "sr_no": 13127
    },
    {
        "name": "Jeanne McGrath",
        "sr_no": 12272
    },
    {
        "name": "Parvathy Sree",
        "sr_no": 11582
    },
    {
        "name": "Parvathy Sree (MPL)",
        "sr_no": 11576
    },
    {
        "name": "Cathryn Winegeart",
        "sr_no": 12553
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "John  Bagonzi",
        "sr_no": 13275
    },
    {
        "name": "Noah Crawford",
        "sr_no": 12210
    },
    {
        "name": "Jenna  Dees",
        "sr_no": 13274
    },
    {
        "name": "Brandon Elkins",
        "sr_no": 11293
    },
    {
        "name": "kristen Steger",
        "sr_no": 13299
    },
    {
        "name": "Patrick  Stevens",
        "sr_no": 12552
    },
    {
        "name": "Mitchell Valenti",
        "sr_no": 12504
    },
    {
        "name": "Mitchell Willis",
        "sr_no": 12263
    },
    {
        "name": "Jeanne McGrath",
        "sr_no": 12272
    },
    {
        "name": "Parvathy Sree",
        "sr_no": 11582
    },
    {
        "name": "Jeanne McGrath",
        "sr_no": 12272
    },
    {
        "name": "Parvathy Sree",
        "sr_no": 11582
    },
    {
        "name": "Parvathy Sree (MPL)",
        "sr_no": 11576
    },
    {
        "name": "Christina  Adan",
        "sr_no": 11259
    },
    {
        "name": "Andrew Leader",
        "sr_no": 13134
    },
    {
        "name": "Diya-Dylan Ahir",
        "sr_no": 12444
    },
    {
        "name": "Samarth Anand",
        "sr_no": 12445
    },
    {
        "name": "Samuel Cannizzaro",
        "sr_no": 13615
    },
    {
        "name": "Adithi Chintha",
        "sr_no": 12679
    },
    {
        "name": "Brandon Elkins",
        "sr_no": 11293
    },
    {
        "name": " Deanna Harp",
        "sr_no": 13327
    },
    {
        "name": "Matthew Kaminski",
        "sr_no": 13601
    },
    {
        "name": "Kayla Marlow",
        "sr_no": 12277
    },
    {
        "name": "Oscar mendoza",
        "sr_no": 13205
    },
    {
        "name": "Tracy Murphy",
        "sr_no": 12811
    },
    {
        "name": "Tyler Ray",
        "sr_no": 13136
    },
    {
        "name": "Abhinav Soma",
        "sr_no": 12447
    },
    {
        "name": "Kevin Stockton",
        "sr_no": 11427
    },
    {
        "name": "Mitchell Willis",
        "sr_no": 12263
    },
    {
        "name": "Jeanne McGrath",
        "sr_no": 12272
    },
    {
        "name": "Bre Rawls",
        "sr_no": 12812
    },
    {
        "name": "Christina  Adan",
        "sr_no": 11259
    },
    {
        "name": "Tanya Brakner",
        "sr_no": 12423
    },
    {
        "name": "Gregory  Desmarais",
        "sr_no": 13579
    },
    {
        "name": " Daniel Fliegelman",
        "sr_no": 13128
    },
    {
        "name": "Craig Henry",
        "sr_no": 11325
    },
    {
        "name": "Jaclyn  McCarthy",
        "sr_no": 12273
    },
    {
        "name": " John  Walerius ",
        "sr_no": 13462
    },
    {
        "name": "Parvathy Sree",
        "sr_no": 11582
    },
    {
        "name": "Parvathy Sree (MPL)",
        "sr_no": 11576
    },
    {
        "name": "Bre Rawls",
        "sr_no": 12812
    },
    {
        "name": "Parvathy Sree",
        "sr_no": 11582
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    },
    {
        "name": "Brandon Emmert",
        "sr_no": 13326
    }
]